module.exports = __webpack_public_path__ + "static/media/login.00b0caea.png";